// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScheduledMessagesEmpty__info-block-f985ca {
  --info-block-text-color: var(--addition-50);
  background: var(--average-background);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/MessagesEmpty/ScheduledMessagesEmpty/ScheduledMessagesEmpty.styles.m.css"],"names":[],"mappings":"AAAA;EACE,2CAAA;EACA,qCAAA;AACF","sourcesContent":[".info-block {\n  --info-block-text-color: var(--addition-50);\n  background: var(--average-background);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"info-block": `ScheduledMessagesEmpty__info-block-f985ca`,
	"infoBlock": `ScheduledMessagesEmpty__info-block-f985ca`
};
module.exports = ___CSS_LOADER_EXPORT___;
